export default __webpack_public_path__ + "static/IN-8003_Quick_Installation_03-0c118e13d68983b22cd68bb875aecc9d.webp";